import React from "react";
import type { RouteObject } from "react-router-dom";
import { PageSuspense } from "../../components/layout/PageTransition";
import { DISCOVER_PATH, INSIGHT_PATH } from "./discoverPaths";

const DiscoverPage = React.lazy(() => import("./DiscoverPage"));
const InsightPage = React.lazy(() => import("./InsightPage"));

export const buildDiscoverRoutes = (): RouteObject[] => [
  { path: DISCOVER_PATH, element: <PageSuspense><DiscoverPage /></PageSuspense> },
  { path: INSIGHT_PATH, element: <PageSuspense><InsightPage /></PageSuspense> },
];
